import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { Dtc } from '../../../../../shared/models/dtc/dtc';
import { DtcQuery } from '../../../../../shared/models/dtc/dtc-query';
import { CommonUtils } from '../../../../common/common-utils';
import { NgClass } from '@angular/common';
import { PreselectionService } from '../../../../services/preselection.service';
import { PreselectionType } from '../../../../../shared/enums/preselection-type';
import { ScrollableBase } from '../../../base/scrollable-base';

@Component({
  selector: 'app-dtc-list',
  imports: [NgClass],
  templateUrl: './dtc-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dtc-list.component.scss',
})
export class DtcListComponent extends ScrollableBase<DtcQuery> {
  @Input() public dtcs?: Dtc[];
  public commonUtils = CommonUtils;

  private preselectionService = inject(PreselectionService);

  public navigateToDtc(id: string | undefined, searchTerm: string | undefined): void {
    if (!id || !searchTerm) {
      return;
    }

    this.preselectionService.configureAndChangeRoute(id, searchTerm, PreselectionType.Dtc);
  }
}
